import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { pdfStyles } from '../../..';
import { InvoiceInterface } from '../../../../interfaces/invoice.interface';

interface Props {
  doc: InvoiceInterface;
}

export const PdfProductsTable = ({ doc }: Props) => {
  const { t } = useTranslation();

  const getToWeighLabel = useCallback(() => {
    if (doc?.productsToBeWeighed) {
      return ` (${t('PDF.PRODUCTS_TO_BE_WEIGHED_LABEL')})`;
    }
  }, [doc?.productsToBeWeighed, t]);

  return (
    <View style={styles.container}>
      <Text style={[pdfStyles.smallTitleRegular, styles.section, styles.center, { flex: 1, paddingLeft: 4 }]}>
        {t('PDF.PRODUCT_TITLE')}
        {getToWeighLabel()}
      </Text>
      <Text style={[pdfStyles.smallTitleRegular, styles.section, styles.center, pdfStyles.width60]}>
        {t('PDF.PRODUCT_QUANTITY')}
      </Text>
      <Text style={[pdfStyles.smallTitleRegular, styles.section, styles.center, pdfStyles.width30]}>
        {t('PDF.PRODUCT_UNIT_TYPE')}
      </Text>
      <Text style={[pdfStyles.smallTitleRegular, styles.section, styles.center, pdfStyles.width60]}>
        {t('PDF.PRODUCT_UNIT_COST')}
      </Text>
      <Text style={[pdfStyles.smallTitleRegular, styles.section, styles.center, pdfStyles.width60]}>
        {t('PDF.PRODUCT_DISCOUNT')} %
      </Text>
      <Text style={[pdfStyles.smallTitleRegular, styles.section, styles.center, pdfStyles.width40]}>
        {t('PDF.PRODUCT_TOTAL_CLEAN_VALUE')}
      </Text>
      <Text style={[pdfStyles.smallTitleRegular, styles.center, pdfStyles.width40]}>
        {t('PDF.PRODUCT_VAT_PERCENTAGE')}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    backgroundColor: '#c9cace',
    padding: 2,
  },
  section: {
    borderRightWidth: 1,
    borderColor: 'white',
  },
  center: {
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
